import { format, parseISO } from 'date-fns';
import { nl } from 'date-fns/locale';

export function FormatDate({ date, format: $format }) {
  if (!date) return null;
  if (typeof date === 'string') {
    date = parseISO(date);
  }

  return format(new Date(date), $format, { locale: nl });
}

export function FromToDateTime({ from, to }) {
  return (
    <>
      <FormatDate date={from} format={"EEEE d MMMM y 'van' HH:mm 'tot '"} />
      <FormatDate date={to} format={'HH:mm'} />
    </>
  );
}
